import {combineReducers} from 'redux';

import app from './app';
import appearance from './appearance';
import meeting from './meeting';
import communication from './communication';
import world from './world';
import media from './media';
import viewboard from './viewboard';
import course from './course';
import guardians from './guardians';
import subscriptionUi from './subscriptionUi';

export default combineReducers({
  app,
  appearance,
  meeting,
  communication,
  world,
  media,
  viewboard,
  course,
  guardians,
  subscriptionUi,
});
